export const FINISH_LOADING = "FINISH_LOADING";
export const START_LOADING = "START_LOADING";

//desktop
export const OPEN_MODAL = "OPEN_MODAL";
export const APP_MAXIMIZED = "APP_MAXIMIZED";

// Browser section
export const OPEN_BROWSER = "OPEN_BROWSER";
export const CLOSE_BROWSER = "CLOSE_BROWSER";
export const OPEN_SELECTED_WINDOW = "OPEN_SELECTED_WINDOW";
export const CLOSE_DELETED_WINDOW = "CLOSE_DELETED_WINDOW";

// File manager section
export const OPEN_FILE_MANAGER = "OPEN_FILE_MANAGER";
export const CLOSE_FILE_MANAGER = "CLOSE_FILE_MANAGER";
export const MAXIMIZE_FILE_MANAGER = "MAXIMIZE_FILE_MANAGER";
export const MINIMIZE_FILE_MANAGER = "MINIMIZE_FILE_MANAGER";
export const RESIZE_FILE_MANAGER = "RESIZE_FILE_MANAGER";
export const ORDER_FILE_MANAGER = "ORDER_FILE_MANAGER";

//  File manager -------> CONTROLL PANNEL
export const OPEN_MUSIC = "OPEN_MUSIC";
export const CLOSE_MUSIC = "CLOSE_MUSIC";

// File Manager --------> Music Section
export const CONTROLL_MUSIC = "CONTROLL_MUSIC";
export const SET_PLAYING_MUSIC = "SET_PLAYING_MUSIC";

// Contact me
export const OPEN_CONTACTME = "OPEN_CONTACTME";
export const CLOSE_CONTACTME = "CLOSE_CONTACTME";

// Gmail pannel
export const CLOSE_GMAIL = "CLOSE_GMAIL";
export const SEND_MESSAGE = "SEND_MESSAGE";

// PORTFOLIO
export const OPEN_PORTFOLIO = "OPEN_PORTFOLIO";
export const CLOSE_PORTFOLIO = "CLOSE_PORTFOLIO";
export const MAXIMIZE_PORTFOLIO = "MAXIMIZE_PORTFOLIO";
export const MINIMIZE_PORTFOLIO = "MINIMIZE_PORTFOLIO";

//SETTING
export const OPEN_SETTING = "OPEN_SETTING";
export const CLOSE_SETTING = "CLOSE_SETTING";
export const CHANGE_BACKGROUND = "CHANGE_BACKGROUND";
export const PICK_COLOR = "PICK_COLOR";
export const SUBMIT_CHANGES = "SUBMIT_CHANGES";
export const ORDER_SETTING = "ORDER_SETTING";
export const MINIMIZE_SETTING = "MINIMIZE_SETTING";
export const MAXIMIZE_SETTING = "MAXIMIZE_SETTING";
export const RESIZE_SETTING = "RESIZE_SETTING";
export const CHANGE_IMAGE = "CHANGE_IMAGE";

//ShutDown
export const OPEN_SHUT_DOWN = "OPEN_SHUT_DOWN";
export const CLOSE_SHUT_DOWN = "CLOSE_SHUT_DOWN";

//APPS SECTION
export const OPEN_CMD = "OPEN_CMD";
export const CLOSE_CMD = "CLOSE_CMD";
export const MAXIMIZE_CMD = "MAXIMIZE_CMD";
export const MINIMIZE_CMD = "MINIMIZE_CMD";
export const RESIZE_CMD = "RESIZE_CMD";
export const ORDER_CMD = "ORDER_CMD";
export const SET_CMD_LOCATION = "SET_CMD_LOCATION";
export const OPEN_TODO = "OPEN_TODO";
export const CLOSE_TODO = "CLOSE_TODO";
export const MAXIMIZE_TODO = "MAXIMIZE_TODO";
export const MINIMIZE_TODO = "MINIMIZE_TODO";
export const RESIZE_TODO = "RESIZE_TODO";
export const ORDER_TODO = "ORDER_TODO";

//TODO
export const UPDATE_TODO = "UPDATE_TODO";

//CALCULATOR
export const OPEN_CALCULATOR = "OPEN_CALCULATOR";
export const CLOSE_CALCULATOR = "CLOSE_CALCULATOR";
export const ORDER_CALCULATOR = "ORDER_CALCULATOR";
export const RESIZE_CALCULATOR = "RESIZE_CALCULATOR";
export const MAXIMIZE_CALCULATOR = "MAXIMIZE_CALCULATOR";
export const MINIMIZE_CALCULATOR = "MINIMIZE_CALCULATOR";

//Weather
export const SET_CITY = "SET_CITY";
export const SET_WEATHER_DATA = "SET_WEATHER_DATA";
export const SET_WEATHER_ERROR = "SET_WEATHER_ERROR";
export const HANDLE_SHOW_WEATHER = "HANDLE_SHOW_WEATHER";

// CODE
export const OPEN_CODE = "OPEN_CODE";
export const CLOSE_CODE = "CLOSE_CODE";
export const MAXIMIZE_CODE = "MAXIMIZE_CODE";
export const MINIMIZE_CODE = "MINIMIZE_CODE";
export const RESIZE_CODE = "RESIZE_CODE";
export const ORDER_CODE = "ORDER_CODE";
export const UPDATE_ROOMS = "UPDATE_ROOMS"
export const SET_CODE_ERROR = "SET_CODE_ERROR"
export const SET_ACTIVE_ROOM = "SET_ACTIVE_ROOM"

//  user
export const LOG_IN = "LOG_IN";
export const LOG_OUT = "LOG_OUT";
export const SET_USER_ERROR = "SET_USER_ERROR";
